<template>
	<div>
		<a-modal :title="'睡眠报告'" :visible="isShowAlert" :maskClosable="false" @cancel="hiddenAlert"
			:dialog-style="{ 'min-width': '900px', 'max-width': '900px', 'border-radius': '16px', 'background': '#FFFFFF00', 'overflow': 'hidden', 'padding-bottom': '0px' }"
			:footer="null" id="old" :zIndex="1001">
			<div class="needGZ_TanWrap" v-if="isShowAlert">
				<div class="needGZ_Tan"
					style="width: 900px; display: flex; flex-direction: column; padding-bottom: 25px; background: #ECF0F3; min-height: 800px;">

					<div v-if="loading"
						style="width:1000px;height:600px;position: fixed;background:#FFFFFF00;z-index: 999999;display:flex;justify-content: center;align-items: center;">
						<a-spin :allSpinning="loading" tip="加载中" :delay="100" size="large"></a-spin>
					</div>

					<div v-if="data" style="display: flex; height: 65px; position: relative;">
						<img v-if="type == 0" style="position: absolute; width: 100%; height: 65px;"
							src="../../../assets/icon_dean_home_alert_bg_1.png" alt="">
						<img v-if="type == 1" style="position: absolute; width: 100%; height: 65px;"
							src="../../../assets/icon_dean_home_alert_bg_3.png" alt="">
						<div
							style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; display: flex; justify-content: space-between; align-items: center;">
							<div style="display: flex; align-items: center; height: 100%;">
								<div style="width: 5px; height: 20px; background: #4A7CE8; border-radius: 0px 3px 3px 0px;">
								</div>
								<div
									style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #1F2635; line-height: 24px; margin-left: 20px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 660px;">
									{{ data.bedName || ' ' }}</div>
								<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 18px; color: #5E6779; line-height: 24px; margin-left: 12px;">{{ data.digitalTwinDateCn || '' }}</div>
							</div>
							<img style="width: 36px; height: 36px; margin-right: 15px; cursor: pointer;"
								src="../../../assets/icon_common_close_1.png" alt="" @click="hiddenAlert" />
						</div>
					</div>

					<div v-if="data" class="needGZ_Cont"
						style="display: flex; flex-direction: row; background: #ECF0F3; margin-top: 15px;">
						<QlBtn :text="'查看完整当日报告'" :images="['icon_common_special_arrow_7', 'icon_common_special_arrow_8']"
							:imageWidth="'16px'" :imageHeight="'16px'" style="align-self: flex-start;"
							@btnClick="lookReport" :paddingLeft="'10px'" :paddingRight="'5px'" :imgIsRight="true"
							:fontWeight="'600'" />
						<QlBtn :text="'查看完整数字画像'" :images="['icon_common_special_arrow_7', 'icon_common_special_arrow_8']"
							:imageWidth="'16px'" :imageHeight="'16px'" style="align-self: flex-start; margin-left: 20px;"
							@btnClick="lookPortrait" :paddingLeft="'10px'" :paddingRight="'5px'" :imgIsRight="true"
							:fontWeight="'600'" />
					</div>

					<div v-if="data"
						style="background: rgba(255,255,255,0.8); border-radius: 16px; border: 1px solid #FFFFFF; margin-top: 15px; margin-left: 24px; margin-right: 24px; position: relative;">
						<div
							style="position: absolute; left: 5px; right: 5px; top: 5px; bottom: 5px; border: 2px rgb(74, 124, 232, 0.15) solid; border-radius: 12px; overflow: hidden;">
							<div class="topCardBg" style="width: 100%; height: 100%;"></div>
						</div>
						<img style="width: 28px; height: 28px; position: absolute; left: -5px; top: -5px;"
							src="../../../assets/icon_dean_home_alert_icon_5.png" alt="">
						<img style="width: 28px; height: 28px; position: absolute; right: -5px; bottom: -5px;"
							src="../../../assets/icon_dean_home_alert_icon_4.png" alt="">
						<img style="width: 25px; height: 40px; position: absolute; right: 0px; top: -15px;"
							src="../../../assets/icon_dean_home_alert_icon_3.png" alt="">
						<div
							style="display: flex; flex-direction: column; justify-content: flex-start; padding-bottom: 20px;">
							<img style="width: 121px; height: 34px; margin-left: 20px; margin-top: 20px; align-self: flex-start;"
								src="../../../assets/icon_dean_home_alert_icon_1.png" alt="">
							<div v-for="(item, index) in data.recommendList || []"
								style="display: flex; margin-top: 10px; margin-bottom: 5px; margin-left: 20px; margin-right: 20px;">
								<div
									style="width: 8px; height: 8px; background: #4A7CE8; opacity: 0.2; border-radius: 4px; margin-top: 8px; margin-right: 5px;">
								</div>
								<div
									style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 22px; flex: 1;">
									{{ item }}</div>
							</div>
						</div>
					</div>

					<div v-if="data && chartDataList && chartDataList.length > 0"
						v-for="(item, index) in chartDataList || []">
						<ContentCardBaseA v-if="item.index != 'ahi' && item.index != 'bcRegular2Num' && item.index != 'breBpm' && item.index != 'breBpm2Num' && item.index != 'obCntTimeLen2' && item.index != 'obCnt' && item.index != 'obTimeLen2' && item.index != 'obTime2Num' && item.index != 'obCnt3Num' && item.index != 'obTime2Cnt3Num'"
							:echartId="'ContentCardBaseA' + index" :option="item.echartsOption" :data="item" :isFold="true" :type="type">
						</ContentCardBaseA>
						<ContentCardBaseB v-if="item.index == 'ahi'" :echartId="'ContentCardBaseB' + index"
							:option="item.echartsOption" :data="item"  :type="type"  :isFold="true"></ContentCardBaseB>
						<ContentCardBaseD v-if="item.index == 'bcRegular2Num'" :echartId="'ContentCardBaseD' + index"
							:option="item.echartsOption" :data="item"  :type="type" :isFold="true"></ContentCardBaseD>
						<ContentCardBaseE v-if="item.index == 'breBpm'" :echartId="'ContentCardBaseE' + index"
							:option="item.echartsOption" :optionAuxiliary="item.echartsOptionAuxiliary" :data="item"  :type="type" :isFold="true"></ContentCardBaseE>
						<ContentCardBaseF v-if="item.index == 'breBpm2Num'" :echartId="'ContentCardBaseF' + index"
							:option="item.echartsOption" :optionAuxiliary="item.echartsOptionAuxiliary" :data="item"  :type="type" :isFold="true"></ContentCardBaseF>
						<ContentCardBaseG v-if="item.index == 'obCntTimeLen2' || item.index == 'obCnt' || item.index == 'obTimeLen2' || item.index == 'obTime2Num' || item.index == 'obCnt3Num' || item.index == 'obTime2Cnt3Num'" :echartId="'ContentCardBaseG' + index"
							:option="item.echartsOption" :optionAuxiliary="item.echartsOptionAuxiliary" :data="item"  :type="type" :isFold="true"></ContentCardBaseG>
					</div>
				</div>
			</div>
		</a-modal>

		<!-- 查看完整当日报告 -->
		<Healthy ref="workProposalAlertHealthy" />

		<!-- 查看完整数字画像 -->
		<PortraitAlert ref="workProposalAlertPortraitAlert" />

		<!-- 弹窗_数字画像 -->
		<tan_needGz_portrait ref="workProposalAlertTan_needGz_portrait"></tan_needGz_portrait>

	</div>
</template>
  
<script>
import Healthy from '../../../component/healthy/healthy.vue';
import PortraitAlert from './portraitAlert.vue';
import tan_needGz_portrait from './tan_needGz_portrait.vue';
import QlBtn from '../../../component/common/qlBtn.vue'
import ContentCardBaseA from '../component/contentCardBaseA.vue'
import ContentCardBaseB from '../component/contentCardBaseB.vue'
import ContentCardBaseD from '../component/contentCardBaseD.vue'
import ContentCardBaseE from '../component/contentCardBaseE.vue'
import ContentCardBaseF from '../component/contentCardBaseF.vue'
import ContentCardBaseG from '../component/contentCardBaseG.vue'

import EchartsDataDeal from '../component/options/echartsDataDeal.js'

import workProposalAlertData from './workProposalAlertData.json'

import WorkProposalFunction from './workProposalFunction.js'

export default {
	components: { QlBtn, ContentCardBaseA, ContentCardBaseB, ContentCardBaseD, ContentCardBaseE, ContentCardBaseF, ContentCardBaseG, Healthy, PortraitAlert, tan_needGz_portrait },
	props: {
		type: {
			type: Number,
			default: 0 // 0 - 红色，1 - 黄色
		},
	},
	watch: {

	},
	data() {
		return {
			isShowAlert: false,
			incomingData: null,

			loading: false,
			data: null,
			chartDataList: null,

			option3: null,
			option4: null,
			option5: null,

			clickId: null,
			digitalTwinDate: null,

			clickId1: null
		};
	},
	created() { },
	mounted() {
	},
	methods: {
		openAlert(item) {
			this.chartDataList = null;
			this.isShowAlert = true;
			this.incomingData = item;
			this.getDetaiData();

			this.$get(
				'api/dean/v5/clickLog', {
					clickType: this.$props.type == 1 ? 6 : 3
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.clickId = res.data.id;
						} 
					} else {
					}
				}, (err) => {}
			);

		},
		hiddenAlert() {
			this.isShowAlert = false;
			this.$get(
				'api/dean/v5/closeLog', {
					id: this.clickId
				},
				(res) => {}, (err) => {}
			);
		},
		exportPdfToUpdateData() {
		},
		lookReport() {
			this.$refs.workProposalAlertHealthy.details({
				"bedId": this.data.bedId,
				bedName: this.data.bedName,
				activeType: 1,
				activeDate: this.data.healthReportDate,
				sn: '',
			}, this.$props.type == 0 ? 'lookAllReport0' : 'lookAllReport1');
		},
		lookPortrait() {
			let data = {
				"bedId": this.data.bedId,
			}
			this.$refs.workProposalAlertTan_needGz_portrait.openComponent_tan_needGz_portrait(data, this.$props.type == 0 ? 'lookAllPortrait0' : 'lookAllPortrait1')
		},
		getDetaiData() {
			this.loading = true;
			let api = '';
			if (this.$props.type == 0) {
				api = 'api/dean/v5/timelyCareElderDetails';
			} else {
				api = 'api/dean/v5/longObserveElderDetails';
			}
			this.$get(
				api,
				{
					bedId: this.incomingData.bedId
				},
				(res) => {
					// res = workProposalAlertData;
					this.loading = false;
					if (res.code == 0) {
						if (res.data) {
							this.dealChartData(res.data.indexList)
							this.data = res.data;

							// let digitalTwinDate = res.data.digitalTwinDate;
							// if (digitalTwinDate && digitalTwinDate.indexOf('-') > 0) {
							// 	let arr = digitalTwinDate.split("-")
							// 	let needDate = '';
							// 	for (let i = 0; i < arr.length; i++) {
							// 		needDate += arr[i];
							// 		if (i == 0) {
							// 			needDate += '年';
							// 		} else if (i == 1) {
							// 			needDate += '月';
							// 		} else {
							// 			needDate += '日';
							// 		}
							// 	}
							// 	this.digitalTwinDate = needDate;
							// }
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					this.loading = false;
					this.$message.error('服务端发生异常');
				}
			);
		},
		dealChartData(arr) {
			// 1.不存在则直接置空
			if (!arr || arr.length == 0) {
				this.chartDataList = null;
				return
			}

			// 2.组装新的图表数组 - 添加新字段 echartsOption、subTitle
			let needArr = [];
			for (let i = 0; i < arr.length; i++) {
				let item = arr[i];
				let needItem = JSON.parse(JSON.stringify(arr[i]));



				// option
				needItem.echartsOption = WorkProposalFunction.getNeedOption(item, this.$props.type);

				// icon
				needItem.icon = WorkProposalFunction.getNeedIcon(item);

				// questionMarkType
				needItem.questionMarkType = WorkProposalFunction.getNeedQuestionMarkType(item);

				// subTitle
				needItem.subTitle = WorkProposalFunction.getNeedSubTitle(item);

				// subQuestionMarkType
				needItem.subQuestionMarkType = WorkProposalFunction.getNeedSubQuestionMarkType(item);

				// leftTip
				needItem.leftTip = WorkProposalFunction.getNeedLeftTip(item);

				// rightTip
				needItem.rightTip = WorkProposalFunction.getNeedRightTip(item);

				// original data
				needItem.originalData = item;

				needArr.push(needItem)
			}
			this.chartDataList = needArr;
		},
	},
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';

.topCardBg {
	background: url('../../../assets/icon_dean_home_alert_icon_2.png') no-repeat no-repeat;
	background-size: 840px 100%;
}
</style>
  